import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content"> {/* NOVO: Container para o conteúdo do rodapé */}
        <p>&copy; {new Date().getFullYear()} Bertolin Soluções. Todos os direitos reservados.</p>
        <div className="social-links"> {/* NOVO: Links de redes sociais no rodapé */}
          <a href="https://www.instagram.com/bertolinsolucoes" target="_blank" rel="noopener noreferrer" aria-label="Instagram da Bertolin Soluções">
            <i className="fab fa-instagram footer-social-icon"></i>
          </a>
          <a href="https://wa.me/5532984835922" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp da Bertolin Soluções">
            <i className="fab fa-whatsapp footer-social-icon"></i>
          </a>
          {/* Adicione outros ícones de redes sociais aqui se desejar */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;